let logsInitialized = false;

export function isDatadogLogsInitialized(): boolean {
  return logsInitialized;
}

export function markDataDogLogsInitialized(): void {
  logsInitialized = true;
}

/** @internal Reset init state between tests. */
export function __resetDatadogLogsInitForTests(): void {
  logsInitialized = false;
}
